




































import Vue from "vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default Vue.extend({
  name: "CategoryForm",
  methods: {
    ...mapMutations({
      resetModalAdd: "productCategory/resetModalAdd"
    }),
    ...mapActions({
      addCategory: "productCategory/addCategory",
      updateCategory: "productCategory/updateCategory"
    }),
    async handleUpdateCategoty() {
      const newCategory = {
        id: this.modal.id,
        name: this.modal.name,
        description: this.modal.description,
        code: this.modal.name
      };
      await this.updateCategory(newCategory);
    },
    handleAddCategoty() {
      const newCategory = {
        name: this.modal.name,
        description: this.modal.description,
        code: this.modal.name
      };
      this.addCategory(newCategory);
    }
  },
  computed: {
    ...mapGetters({
      modal: "productCategory/modal"
    })
  }
});
